module.exports = __webpack_public_path__ + "media/images/flags/64/Kuwait-23cea25afb0225c15418119529e055be.png";